import appConfig from './app.config';
import routesConfig from './app.routes';
import appLoader from './app.loader';
import httpInterceptor from './httpInterceptor';

import angular from 'angular';

import 'angular-animate';
import 'angular-aria';
import 'angular-material';
import 'angular-messages';
import '@uirouter/angularjs';
import 'ng-file-upload';
import 'angular-sanitize';
import 'angular-vs-repeat';

// Components
import APPLICATION_EVENTS from './constants/applicationEvents.constant';
import EVALUATION_STATUSES from './constants/evaluationStatuses.constant';
import STATES from './constants/state.constants';
import USER_ROLES from './constants/userRoles.constants';
import root from './root/rootComponent';
import home from './pages/home/homeComponent';
import login from './pages/login/loginComponent';
import forgotPassword from './pages/login/forgotPassword/forgotPasswordComponent';
import resetPassword from './pages/login/resetPassword/resetPasswordComponent';
import welcomeComponent from './pages/login/welcome/welcomeComponent';
import topbar from './components/topbar/topbarComponent';
import footer from './components/footer/footerComponent';
import imagePopup from './components/imagePopup/imagePopupComponent';
import recentEvaluations from './components/recentEvaluations/RecentEvaluationsComponent';

import manageSkills from './pages/manageSkills/ManageSkillsComponent';

import AsteriskDirective from './directives/asterisk/asterisk.directive';
import evaluation from './pages/evaluation';
import user from './pages/user';
import productsList from './pages/lists/productsList/productsListComponent';
import evaluationsList from './pages/lists/evaluationsList/evaluationsListComponent';
import myEvaluationList from './pages/lists/myEvaluationList/myEvaluationListComponent';
import mySubEvaluationList from './pages/lists/mySubEvaluationList/mySubEvaluationsListComponent';
import clientForm from './pages/clientForm/clientFormComponent';
import clientConfirmed from './pages/clientConfirmed/clientConfirmedComponent';

// Filters
import FiltersModule from './filters';

export default angular.module('app', [
    root,
    home,
    login,
    forgotPassword,
    resetPassword,
    welcomeComponent,
    topbar,
    footer,
    imagePopup,
    manageSkills,
    evaluation.name,
    user.name,
    productsList,
    evaluationsList,
    myEvaluationList,
    mySubEvaluationList,
    clientForm,
    clientConfirmed,
    recentEvaluations,
    FiltersModule.name,
    'ngMaterial',
    'ngMessages',
    'ui.router',
    'ngFileUpload',
    'ngSanitize',
    'vs-repeat',
])
    .config(appConfig)
    .config(routesConfig)
    .config(appLoader)
    .config(httpInterceptor)
    .constant('stateConstants', STATES)
    .constant('userRolesConstants', USER_ROLES)
    .constant('applicationEvents', APPLICATION_EVENTS)
    .constant('evaluationStatuses', EVALUATION_STATUSES)
    .directive('asterisk', AsteriskDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/app.module.js